import * as patientType from "../../action/actiontype/PatientType/PatientType";

const patientReducer = (state = {}, action) => {
    switch (action.type) {
       
            // Patient Register
        case patientType.PATIENT_REQUEST:
            return {
                ...state,
                patientLoading: true,
                patientResponse: {},
                patientError: null
            }
        case patientType.PATIENT_SUCCESS:
            return {
                ...state,
                patientLoading: false,
                patientResponse: action.payload,
                patientError: null
            }
        case patientType.PATIENT_FAILURE:
            return {
                ...state,
                patientLoading: false,
                patientResponse: action.payload,
                patientError: {}
            }

        // Patient List

        case patientType.PATIENT_REQUEST_LIST:
            return {
                ...state,
                patientListLoading: true,
                patientListResponse: {},
                patientListError: null
            }
        case patientType.PATIENT_SUCCESS_LIST:
            return {
                ...state,
                patientListLoading: false,
                patientListResponse: action.payload,
                patientListError: null
            }
        case patientType.PATIENT_FAILURE_LIST:
            return {
                ...state,
                patientListLoading: false,
                patientListResponse: action.payload,
                patientListError: {}
            }

        // Upgrade Register
        case patientType.PATIENT_REQUEST_UPGRADE:
            return {
                ...state,
                patientUpgradeLoading: true,
                patientUpgradeResponse: {},
                patientUpgradeError: null
            }
        case patientType.PATIENT_SUCCESS_UPGRADE:
            return {
                ...state,
                patientUpgradeLoading: false,
                patientUpgradeResponse: action.payload,
                patientUpgradeError: null
            }
        case patientType.PATIENT_FAILURE_UPGRADE:
            return {
                ...state,
                patientUpgradeLoading: false,
                patientUpgradeResponse: action.payload,
                patientUpgradeError: {}
            }
        // GetById
        case patientType.PATIENT_REQUEST_GETBYID:
            return {
                ...state,
                patientGetIdLoading: true,
                patientGetIdResponse: {},
                patientGetIdError: null
            }
        case patientType.PATIENT_SUCCESS_GETBYID:
            return {
                ...state,
                patientGetIdLoading: false,
                patientGetIdResponse: action.payload,
                patientGetIdError: null
            }
        case patientType.PATIENT_FAILURE_GETBYID:
            return {
                ...state,
                patientGetIdLoading: false,
                patientGetIdResponse: action.payload,
                patientGetIdError: {}
            }
        // patient update    

        case patientType.PATIENT_REQUEST_UPDATE:
            return {
                ...state,
                patientUpdateLoading: true,
                patientUpdateResponse: {},
                patientUpdateError: null
            }
        case patientType.PATIENT_SUCCESS_UPDATE:
            return {
                ...state,
                patientUpdateLoading: false,
                patientUpdateResponse: action.payload,
                patientUpdateError: null
            }
        case patientType.PATIENT_FAILURE_UPDATE:
            return {
                ...state,
                patientUpdateLoading: false,
                patientUpdateResponse: action.payload,
                patientUpdateError: {}
            }


        // Patient Delete
        case patientType.PATIENT_REQUEST_DELETE:
            return {
                ...state,
                patientDeleteLoading: true,
                patientDeleteResponse: {},
                patientDeleteError: null
            }
        case patientType.PATIENT_SUCCESS_DELETE:
            return {
                ...state,
                patientDeleteLoading: false,
                patientDeleteResponse: action.payload,
                patientDeleteError: null
            }
        case patientType.PATIENT_FAILURE_DELETE:
            return {
                ...state,
                patientDeleteLoading: false,
                patientDeleteResponse: action.payload,
                patientDeleteError: {}
            }

        default:
            return state;
    }
}

export default patientReducer;